import { useParams } from "react-router";

export const useNumericParam = (paramName: string): number | null => {
  const params = useParams();
  const value = params[paramName];

  if (!value) return null;

  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? null : parsed;
};
